export const inputCls =
  "w-full border border-[#26282E]/15 bg-white px-4 py-3.5 text-[15px] text-[#26282E] placeholder:text-[#8A8D94] focus:border-[#2F5D8C] focus:outline-none transition-colors duration-300 rounded-md";

export function Field({ label, optional, htmlFor, children }) {
  return (
    <div className="space-y-2.5">
      <label
        htmlFor={htmlFor}
        className="block font-mono text-[11px] uppercase tracking-[0.22em] text-[#5B5E66]"
      >
        {label}
        {optional && (
          <span className="ml-2 font-sans normal-case tracking-normal text-[#8A8D94]">optional</span>
        )}
      </label>
      {children}
    </div>
  );
}

export function RadioCards({ options, value, onChange, testid, cols = "sm:grid-cols-3" }) {
  return (
    <div className={`grid gap-2 ${cols}`} role="radiogroup" data-testid={testid}>
      {options.map((opt) => (
        <button
          type="button"
          key={opt.value}
          data-testid={`${testid}-${opt.value}`}
          onClick={() => onChange(opt.value)}
          aria-pressed={value === opt.value}
          className={`rounded-md border px-4 py-3.5 text-left text-sm leading-snug transition-colors duration-300 ${
            value === opt.value
              ? "border-[#2F5D8C] bg-[#2F5D8C]/10 text-[#26282E] font-semibold"
              : "border-[#26282E]/12 bg-white text-[#5B5E66] hover:border-[#26282E]/30 hover:text-[#26282E]"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
